/*
 * Hamilton Sinkler Custom Wishlist Toolbar
 * Description: Handles search, sort, global selection, pagination, quantity, add-to-cart, removal, and PDF button interactions.
 * Dependencies: hs-wishlist-core.js, hs-wishlist-utils.js, hs-wishlist-store.js, hs-wishlist-renderer.js, hs-wishlist-api.js, hs-wishlist-cart.js, hs-wishlist-pdf.js
 * Public Methods: mount, sync
 * Private Methods: selectedItems, itemIds, bindEvents, removeItems
 * Version: 1.1.0
 */
(function (window) {
  'use strict';
  var HS = window.HSWishlist, utils = HS.get('utils'), store = HS.get('store'), api = HS.get('api'), cart = HS.get('cart'), pdf = HS.get('pdf');
  var root;
  function selectedItems() { var state = store.getState(); return state.items.filter(function (item) { return state.selectedItems.indexOf(item.id) > -1; }); }
  function itemIds(items) { return (items || []).map(function (item) { return item.id; }); }
  function actionLabel(state, item) { var s = state.settings || {}, isDesigner = state.customer && state.customer.isDesigner; return item && item.noPrice ? 'Contact us' : (isDesigner ? (s.customerCtaText || 'Add to order') : (s.addToCartText || 'Add to cart')); }
  function setButtonState(button, label, disabled) { 
    if (!button) return; 
    var labelEl = button.querySelector('.hs-wishlist-toolbar__label');
    if (labelEl) {
        labelEl.textContent = label;
    } else {
        button.textContent = label;
    }
    button.disabled = disabled; 
  }
  function removeItems(items) {
    return items.reduce(function (promise, item) { return promise.then(function () { return api.removeWishlist(item); }); }, Promise.resolve()).then(function () {
      var ids = itemIds(items), state = store.getState(), next = state.items.filter(function (item) { return ids.indexOf(item.id) === -1; });
      store.setItems(next, { currentPage: Math.min(state.page, Math.max(1, Math.ceil(next.length / Number(state.settings.productsPerPage || 12)))), totalRecords: next.length });
      store.resetSelection();
    }).catch(function (error) { HS.emit('wishlist:error', { message: error.message }); throw error; });
  }
  function sync(state) {
    var hasSelection = state.selectedItems.length > 0, designer = state.customer && state.customer.isDesigner, allIds = itemIds(state.items), selectAll = utils.qs('[data-hs-wishlist-select-all]', root), search = utils.qs('[data-hs-wishlist-search]', root), sort = utils.qs('[data-hs-wishlist-sort]', root), searchRow = search && search.closest('.hs-wishlist-toolbar__row'), sortRow = sort && sort.closest('.hs-wishlist-toolbar__row');
    utils.qsa('[data-hs-wishlist-add-selected], [data-hs-wishlist-remove-selected], [data-hs-wishlist-pdf]', root).forEach(function (button) { button.disabled = !hasSelection; });
    utils.qsa('[data-hs-wishlist-pdf="quote-retail"], [data-hs-wishlist-pdf="quote-trade"], [data-hs-wishlist-pdf="product-list"]', root).forEach(function (button) { button.hidden = !designer || !state.settings.enableQuotes; });
    utils.qsa('[data-hs-wishlist-pdf="request-quote"]', root).forEach(function (button) { button.hidden = !designer || !state.settings.enableRequestQuote; });
    if (search) { search.disabled = !state.settings.enableSearch; }
    if (searchRow) { searchRow.hidden = !state.settings.enableSearch; }
    if (sort) { sort.disabled = !state.settings.enableFilter; }
    if (sortRow) { sortRow.hidden = !state.settings.enableFilter; }
    if (selectAll) {
      selectAll.checked = allIds.length > 0 && allIds.every(function (id) { return state.selectedItems.indexOf(id) > -1; });
      selectAll.indeterminate = !selectAll.checked && state.selectedItems.length > 0;
      selectAll.disabled = allIds.length === 0;
    }
  }
  function bindEvents() {
    var search = utils.qs('[data-hs-wishlist-search]', root), sort = utils.qs('[data-hs-wishlist-sort]', root);
    if (search) search.addEventListener('input', utils.debounce(function () { store.setSearch(search.value); }, 250));
    if (sort) sort.addEventListener('change', function () { store.setSort(sort.value); });
    root.addEventListener('change', function (event) {
      var quantityId = event.target.getAttribute('data-hs-wishlist-quantity');
      if (event.target.matches('[data-hs-wishlist-item-select]')) store.toggleSelectedItem(event.target.value);
      if (event.target.matches('[data-hs-wishlist-select-all]')) store.setSelectedItems(event.target.checked ? itemIds(store.getState().items) : []);
      if (quantityId) store.updateItemQuantity(quantityId, event.target.value);
    });
    root.addEventListener('input', utils.debounce(function (event) {
      var quantityId = event.target && event.target.getAttribute('data-hs-wishlist-quantity');
      if (quantityId) store.updateItemQuantity(quantityId, event.target.value);
    }, 150));
    root.addEventListener('click', function (event) {
      var pageButton = event.target.closest('[data-hs-wishlist-page]'), addButton = event.target.closest('[data-hs-wishlist-add-cart]'), removeButton = event.target.closest('[data-hs-wishlist-remove]'), typeButton = event.target.closest('[data-hs-wishlist-pdf]'), state = store.getState(), page = pageButton && pageButton.getAttribute('data-hs-wishlist-page'), add = addButton && addButton.getAttribute('data-hs-wishlist-add-cart'), remove = removeButton && removeButton.getAttribute('data-hs-wishlist-remove'), type = typeButton && typeButton.getAttribute('data-hs-wishlist-pdf');
      if (page) store.setPage(Number(page));
      if (add) {
        var item = state.items.filter(function (entry) { return entry.id === add; })[0];
        if (item) {
          setButtonState(addButton, 'Adding...', true);
          cart.addItem(item).then(function () {
            setButtonState(addButton, 'Added', false);
            HS.emit('wishlist:toast', { message: 'Added to cart', type: 'success' });
            window.setTimeout(function () { setButtonState(addButton, actionLabel(state, item), false); }, 1600);
          }).catch(function (error) { setButtonState(addButton, 'Try again', false); HS.emit('wishlist:error', { message: error.message }); });
        }
      }
      if (remove) removeItems(state.items.filter(function (item) { return item.id === remove; }));
      if (event.target.closest('[data-hs-wishlist-add-selected]')) {
        var selected = selectedItems().filter(function (item) { return !item.noPrice; });
        if (!selected.length) { setButtonState(event.target, 'Try again', false); HS.emit('wishlist:error', { message: 'No purchasable items selected.' }); return; }
        
        setButtonState(event.target, 'Adding...', true);
        cart.addItems(selected).then(function () {
          setButtonState(event.target, 'Added', false);
          HS.emit('wishlist:toast', { message: 'Added selected items to cart', type: 'success' });
          window.setTimeout(function () { setButtonState(event.target, 'Add Selected Items To Orders', false); }, 1600);
        }).catch(function (error) { setButtonState(event.target, 'Try again', false); HS.emit('wishlist:error', { message: error.message }); });
      }
      if (event.target.matches('[data-hs-wishlist-remove-selected]')) removeItems(selectedItems());
      if (type) {
        setButtonState(typeButton, 'Processing...', true);
        pdf.generate(type, selectedItems(), Object.assign({}, store.getState().settings, { customer: store.getState().customer })).then(function () {
          setButtonState(typeButton, 'Downloaded', false);
          HS.emit('wishlist:toast', { message: 'PDF generated', type: 'success' });
          window.setTimeout(function () { setButtonState(typeButton, type === 'request-quote' ? 'Request a Quote' : (type === 'quote-retail' ? 'Quote at Retail' : (type === 'quote-trade' ? 'Quote at Trade' : 'List of Products Only')), false); }, 1600);
        }).catch(function () { setButtonState(typeButton, 'Try again', false); });
      }
    });
  }
  function mount(container) { root = container; bindEvents(); store.subscribe(sync); }
  HS.define('toolbar', { mount: mount, sync: sync });
})(window);

